import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { publicRouters } from "./routes/routes";
import EmptyLayout from "./Layouts/EmptyLayout/EmptyLayout";
import { Fragment } from "react/jsx-runtime";

function App() {

  return (
    <Router>
      <div className="App">
        <Routes>
          {publicRouters.map((route, index) => {
            const Page = route.component;
            let Layout = EmptyLayout;

            if (route.layout) {
              Layout = route.layout;
            } else {
              Layout = Fragment;
            }

            return (
              <Route
                key={index}
                path={route.path}
                element={
                  <Layout>
                    <Page {...route.props} />
                  </Layout>
                }
              />
            );
          })}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
